import type { InvoiceSystemSettings } from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { InvoiceSystemSettingsInputZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelID", "createdAt", "updatedAt"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type InvoiceSystemSettingsFormModel = AutoGeneratorForFormModel<
	InvoiceSystemSettingsInputZodSchemaType,
	ExcludeKeys,
	Omit<InvoiceSystemSettings, "createdAt" | "updatedAt">
>;
